/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import PropTypes from "prop-types";

import Dropdown from "@shared/v2/Dropdown";

const numbersOnly = (phoneNumber) =>
  phoneNumber ? phoneNumber.replace(/\s+/g, "").replace(/\D+/g, "") : null;

const CustomPhoneNumberOption = ({ componentProps, children, disabledNumber }) => (
  <Dropdown.Option
    {...componentProps}
    className="!tw-flex tw-justify-between"
    isDisabled={numbersOnly(disabledNumber) === numbersOnly(componentProps?.data?.value)}
    preserveStyle
  >
    <span>{children}</span>
    <span className="tw-capitalize">{componentProps?.data?.category}</span>
  </Dropdown.Option>
);

export default CustomPhoneNumberOption;

CustomPhoneNumberOption.propTypes = {
  componentProps: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
  disabledNumber: PropTypes.string.isRequired,
};
